import { Injectable } from "@angular/core";

export interface MeetingDay {
  day: number;
  over: boolean;
  locations: number[];
}

export interface Calendar {
  year: any;
  month: any;
  week: any[];
}

export interface KeepDay {
  day: number;
  month: number;
  year: number;
  locationId: number;
}

export const Second = {
  TwoDays: 172800,
};

@Injectable()
export class CalendarProvider {
  constructor() {}
  public getCalendarYM(year: number, month: number): Calendar {
    let calendar: Calendar = this.generateCalendar(year, month);
    return calendar;
  }
  private generateCalendar(year: number, month: number): Calendar {
    let day: number = this.calcDay(year, month);
    let yearDays: number[] = [
      0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
    ];
    let leapYearDays: number[] = [
      0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
    ];
    day -= 1;
    if (day < 0) {
      day += 7;
    }

    let leapYearFlag: boolean = this.judgeLeapYear(year);
    let resultWeek: any[] = [];

    if (leapYearFlag) {
      resultWeek = this.generateDate(year, leapYearDays, month, day);
    } else {
      resultWeek = this.generateDate(year, yearDays, month, day);
    }
    let calendar: Calendar = {
      year: year,
      month: month,
      week: resultWeek,
    };
    return calendar;
  }
  private calcDay(year: number, month: number): number {
    var startDate = new Date(year, month - 1, 1);
    return startDate.getDay() + 1;
  }

  private judgeLeapYear(year: number): boolean {
    if (year % 400 == 0) {
      return true;
    } else if (year % 100 == 0) {
      return true;
    } else if (year % 4 == 0) {
      return true;
    } else {
      return false;
    }
  }
  private generateDate(
    year: number,
    yearDates: number[],
    month: any,
    firstDay: number
  ): any[] {
    let currentDay: number = 1;
    let otherDay: number = 1;
    let firstDayChk: boolean = false;
    let resultMonth: any[] = [];
    for (var weekIndex = 0; weekIndex < 6; weekIndex++) {
      var week = [];
      for (var i: number = 1; i <= 7; i++) {
        var day = {};
        day["day"] = "";
        if (i <= firstDay && !firstDayChk) {
          let lastMonth = this.lastMonth(year, month);
          day["day"] = yearDates[lastMonth[1]] - firstDay + i;
          day["noShow"] = true;
        } else {
          if (!firstDayChk) {
            firstDayChk = true;
          }
          if (currentDay <= yearDates[month]) {
            day["day"] = currentDay;
          } else {
            day["day"] = otherDay;
            day["noShow"] = true;
            otherDay += 1;
          }
          currentDay += 1;
        }
        week.push(day);
      }
      resultMonth.push(week);
    }
    return resultMonth;
  }
  public getToday(): number[] {
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth() + 1;
    let date = today.getDate();
    return [year, month, date];
  }

  public getDateNumArray(date: Date): number[] {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return [year, month, day];
  }

  public nextMonth(year: number, month: number): number[] {
    let nextYear: number = year;
    let nextMonth: number = month + 1;
    if (13 <= nextMonth) {
      nextMonth = 1;
      nextYear = nextYear + 1;
    }
    return [nextYear, nextMonth];
  }
  public lastMonth(year: number, month: number): number[] {
    let lastYear: number = year;
    let lastMonth: number = month - 1;
    if (lastMonth <= 0) {
      lastMonth = 12;
      lastYear = lastYear - 1;
    }
    return [lastYear, lastMonth];
  }

  public formatDate(date: string): string {
    let dateISO = new Date(date);
    dateISO.setHours(dateISO.getHours() - 9);

    const weekOfDate: string[] = ["日", "月", "火", "水", "木", "金", "土"];
    return (
      dateISO.getFullYear() +
      "年" +
      (dateISO.getMonth() + 1) +
      "月" +
      dateISO.getDate() +
      "日 (" +
      weekOfDate[dateISO.getDay()] +
      ")"
    );
  }

  public setOtherForExcludedDays(
    calendar: Calendar,
    minDate: Date,
    maxDate: Date,
    keepDays: KeepDay[]
  ): Calendar {
    let minYear: number = minDate.getFullYear();
    let minMonth: number = minDate.getMonth() + 1;
    let minDay: number = minDate.getDate();

    let maxYear: number = maxDate.getFullYear();
    let maxMonth: number = maxDate.getMonth() + 1;
    let maxDay: number = maxDate.getDate();

    if (calendar.year === minYear && calendar.month === minMonth) {
      for (let week of calendar.week) {
        week.map((day: any) => {
          if (!day.noShow && day.day < minDay) {
            day["over"] = true;
            if (day["keep"]) day["keep"] = false;
          }
          return day;
        });
      }
    }

    if (calendar.year === maxYear && calendar.month === maxMonth) {
      for (let week of calendar.week) {
        week.map((day: any) => {
          if (!day.noShow && day.day > maxDay) {
            day["over"] = true;
            if (day["keep"]) day["keep"] = false;
          }
          return day;
        });
      }
    }

    keepDays.forEach((keepDay: KeepDay) => {
      if (keepDay.year !== calendar.year || keepDay.month !== calendar.month)
        return calendar;
      for (let week of calendar.week) {
        // TODO: dayの型作る
        week.map((day: any) => {
          if (!day.noShow) {
            if (day.day == keepDay.day) {
              if (day["locations"]) {
                day["locations"].push(keepDay.locationId);
              } else {
                day["locations"] = new Array();
                day["locations"].push(keepDay.locationId);
              }
            }
          }
          return day;
        });
      }
    });

    return calendar;
  }

  public isDateFirstMorePastThanDateSecond(
    isoStringDate1: string,
    isoStringDate2: string
  ): boolean {
    let stringDate1: string = isoStringDate1.split("T")[0];
    let stringDate2: string = isoStringDate2.split("T")[0];

    let date1Nums: string[] = stringDate1.split("-");
    let date2Nums: string[] = stringDate2.split("-");

    const year1: string = date1Nums[0];
    const month1: string = date1Nums[1];
    const day1: string = date1Nums[2];

    const year2: string = date2Nums[0];
    const month2: string = date2Nums[1];
    const day2: string = date2Nums[2];

    if (year1 == year2) {
      if (month1 == month2) {
        return day1 < day2;
      } else {
        return month1 < month2;
      }
    } else {
      return year1 < year2;
    }
  }

  public setLocalISODate(tagetDate: Date): string {
    return tagetDate
      .toLocaleString("ja-JP")
      .replace(/\/(\d)(?!\d)/g, "/0$1")
      .replace(/\//g, "-")
      .replace(/\x20/g, "T")
      .replace(/T(\d):/, "T0$1:");
  }

  public hasPassedMorning(displayedLastTime: string): boolean {
    if (displayedLastTime) {
      let targetDate: Date = new Date();
      targetDate.setDate(targetDate.getDate());
      targetDate.setHours(8);
      targetDate.setMinutes(0);
      targetDate.setSeconds(0);
      if (targetDate > new Date()) {
        return false;
      }
      if (new Date(JSON.parse(displayedLastTime)) > targetDate) {
        return false;
      }
    }
    return true;
  }

  public hasPassedTwoWeeks(targetDate: Date): boolean {
    let dateTwoWeeksBefore = new Date();
    dateTwoWeeksBefore.setDate(dateTwoWeeksBefore.getDate() - 14);

    return targetDate < dateTwoWeeksBefore;
  }
}



// WEBPACK FOOTER //
// ./src/providers/calendar/calendar.ts